import clsx from 'clsx';
import { staticHomeHeroCopy } from '@/hooks/useHomepageHero';

/** Placeholder hero matching carousel dimensions while platform hero settings load (Phase 3a). */
export function HeroCarouselSkeleton({ className }: { className?: string }) {
  const copy = staticHomeHeroCopy();

  return (
    <section
      className={clsx(
        'relative overflow-hidden bg-gradient-to-br from-brand-800 via-brand-700 to-brand-900 text-white',
        className,
      )}
      aria-busy="true"
      aria-label="Loading homepage hero"
    >
      <div className="mx-auto flex min-h-[280px] max-w-listing flex-col justify-center px-4 py-12 sm:min-h-[340px] sm:px-6 lg:min-h-[400px]">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70">{copy.badge}</p>
        <h1 className="mt-2 max-w-2xl font-display text-3xl font-normal leading-tight sm:text-4xl lg:text-5xl">
          {copy.headline}
        </h1>
        <p className="mt-3 max-w-xl text-sm text-white/85 sm:text-base">{copy.tagline}</p>
        <div className="mt-6 h-10 w-36 animate-pulse rounded-lg bg-white/20" aria-hidden />
      </div>
    </section>
  );
}
